import { render, staticRenderFns } from "./SliderPage.vue?vue&type=template&id=5fea2ea0&scoped=true&"
import script from "./SliderPage.vue?vue&type=script&lang=js&"
export * from "./SliderPage.vue?vue&type=script&lang=js&"
import style0 from "./SliderPage.vue?vue&type=style&index=0&id=5fea2ea0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fea2ea0",
  null
  
)

export default component.exports